export default __webpack_public_path__ + "static/media/medium.aa202e42.svg";